import { render, staticRenderFns } from "./ExportAccountStatement.vue?vue&type=template&id=02227f56"
import script from "./ExportAccountStatement.vue?vue&type=script&lang=js"
export * from "./ExportAccountStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports